import * as React from 'react'
import useWindowSize from '../../hooks/useWindowSize'
import determineButtonText from '../../utils/determineButtonText'
import Typography from '../Typography'
import * as Styled from './Button.styles'

const Button = ({
  children,
  variant = null,
  type = 'button',
  color = 'primary',
  rounded = 'min',
  shadow = true,
  outlined = false,
  ghost = false,
  gradient = false,
  leftIcon = null,
  rightIcon = null,
  mobileText = null,
  visibility,
  ...props
}) => {
  const windowSize = useWindowSize()
  const buttonText = determineButtonText(
    windowSize?.width,
    mobileText,
    children
  )
  let textVariant = null

  if (variant === 'small') {
    textVariant = 'small'
  } else if (variant === 'feature') {
    textVariant = 'feature'
  } else if (variant === 'hero') {
    textVariant = 'h5'
  } else if (variant === 'mega') {
    textVariant = 'feature'
  }

  return (
    <Styled.Button
      className={`leshen-button leshen-button-${variant}`}
      variant={variant}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      gradient={gradient}
      color={color}
      ghost={ghost}
      tabIndex="0"
      rounded={rounded}
      shadow={shadow}
      outlined={outlined}
      type={type}
      visibility={visibility}
      {...props}
    >
      {leftIcon}
      {buttonText && (
        <Typography
          className="button-text"
          variant={textVariant}
          rendersAs="span"
        >
          {buttonText}
        </Typography>
      )}
      {rightIcon}
    </Styled.Button>
  )
}

export default Button
